module.exports = __webpack_public_path__ + "img/media-pic-2.2de9e37f.png";